import React from "react"
import { setConfiguration } from "react-grid-system"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import GlobalStyle from "styleguide/styles/global-style"
import { breakpoints, containerWidths } from "styleguide/styles/grid"
import Footer from "./Footer"

setConfiguration({
  maxScreenClass: 'xl',
  breakpoints,
  containerWidths,
  gutterWidth: 32,
})

interface Props {
  header: React.ReactNode
  main: React.ReactNode
}

const Layout = ({ header, main }: Props) => (
    <>
      <GlobalStyle />
      <header>{header}</header>
      <main>{main}</main>
      <Footer />
    </>
  )

export default Layout
